import {Card, Col, Row} from 'antd'
import {TargetCountsCard} from './target-counts-card'
import {AlertCountsChart} from './alert-counts-chart'
import {TemperatureHistogramCard} from './temperature-histogram-card'
import {widthSmall} from 'helpers/style'
import {CARDS_GUTTER} from 'helpers/dashboards'

const DAYS_TO_SHOW = 7

export const MetricsCards = ({query}) =>
  query?.t_id || query?.s_id || query?.g_id || query?.tg_id ? (
    <Row gutter={CARDS_GUTTER} style={{margin: '1em'}}>
      <Col xs={24} md={8}>
        <TargetCountsCard query={query} width={widthSmall} />
      </Col>
      <Col xs={24} md={8}>
        <Card className={`w-${widthSmall} h-52 font-bold`}>
          <AlertCountsChart query={query} days={DAYS_TO_SHOW} width={widthSmall} />
        </Card>
      </Col>
      <Col xs={24} md={8}>
        <TemperatureHistogramCard query={query} width={widthSmall} />
      </Col>
    </Row>
  ) : (
    <></>
  )

export default MetricsCards
